import { observable, action, runInAction, computed, toJS } from 'mobx'
import Api from '@api/xi_feng/jiamengGoods.js'

class Store {
  @observable list = []
  @observable sortList = []
  @observable sortModalVisible = false

  @observable closeModalVisible = false
  @observable closeModalInfo = {}
  @action
  setStoreData = (type, value) => {
    this[type] = value
  }

  @computed
  get listLen() {
    return this.list.length
  }

  @computed
  get sortListLen() {
    return this.sortList.length
  }

  @action
  getPropertyList = async () => {
    const { data, success } = await Api.getPropertyList()
    if (success) {
      this.list = data
      this.sortList = data.filter(item => item.hidden == 0)
    }
  }

  @action
  showCloseModal = params => {
    this.closeModalVisible = true
    this.closeModalInfo = params
  }
  @action
  onCloseModalOk = () => {
    this.changeProperty(this.closeModalInfo.recordId, '1')
    this.onCloseMoalCancle()
  }
  @action
  onCloseMoalCancle = () => {
    runInAction(() => {
      this.closeModalVisible = false
      this.closeModalInfo = {}
    })
  }

  @action
  changeProperty = async (id, status) => {
    const { success } = await Api.changeProperty({
      id,
      status
    })
    if (success) {
      this.getPropertyList()
    }
  }

  @action
  orderFn = async (id, index, direction) => {
    let orderId = ''
    if (direction == 'up') {
      if (index === 0) {
        return
      }
      orderId = toJS(this.list)[index - 1].id
    } else if (direction == 'down') {
      if (index === this.sortList.length - 1) {
        return
      }
      orderId = toJS(this.list)[index + 1].id
    } else {
      orderId = toJS(this.list)[0].id
    }
    let { success } = await Api.propertyOrder({ ids: [id, orderId] })
    if (success) {
      this.getPropertyList()
    }
  }
}
export default Store
